import React, { useState } from 'react'
import { Modal } from '@web/walter-ui-kit'
import Content from './Content'
import AppModal from './AppModal'
import { useCardDetailsStore } from '~store/cardDetails'

function CardTransactionModal() {
    const [isAppOpen, setIsAppOpen] = useState(false)

    const {
        data: { tx, isOpen },
        setData,
    } = useCardDetailsStore()

    const onClose = () => setData({ isOpen: false })
    const onAppModalOpen = () => setIsAppOpen(true)

    return (
        <>
            <AppModal isOpen={isAppOpen} onClose={() => setIsAppOpen(false)} />
            <Modal onClose={onClose} isOpen={isOpen} dataPointer="details_modal" size="xs" withHeaderBorder={false}>
                <Content data={tx} onAppModalOpen={onAppModalOpen} onClose={onClose} />
            </Modal>
        </>
    )
}

export default CardTransactionModal
